<template>
    <div class="loading-wrapper" v-if="display">
        <div class="loader">Loading...</div>
    </div>
</template>

<script>
    export default {
        name: 'loader',
        props: ['display']
    }
</script>

<style>
    .loading-wrapper {
        height: 100px;
        width: 100%
    }

    .loader,
    .loader:before,
    .loader:after {
        background-color: #ccb26d;
        background-position: -100px -100px;
        animation: load1 1s infinite ease-in-out;
        width: 1em;
        height: 4em;
    }

    .loader {
        color: #ccb26d;
        text-indent: -9999em;
        margin: 33px auto;
        position: relative;
        font-size: 11px;
        transform: translateZ(0);
        animation-delay: -0.16s;
    }

    .loader:before,
    .loader:after {
        position: absolute;
        top: 0;
        content: '';
    }

    .loader:before {
        left: -1.5em;
        animation-delay: -0.32s;
    }

    .loader:after {
        left: 1.5em;
    }
</style>


// WEBPACK FOOTER //
// src/components/GlobalSegments/Loader.vue